import React, { useState } from 'react';
import './Testimonials.css';

function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const testimonials = [
    {
      name: "DARLENE ROBERTSON",
      company: "SEO COMPANY NAME",
      text: "Le portfolio de Viviworks.IA met en lumière la diversité et l'efficacité de nos projets conçus avec l'appui de l'intelligence artificielle. Grâce à l'IA, nous adaptons chaque création aux besoins uniques de nos clients, en combinant données, design et stratégie digitale pour atteindre des résultats mesurables. Découvrez comment l'intelligence artificielle amplifie notre créativité et propulse nos clients vers le succès en ligne."
    },
    {
      name: "DARLENE ROBERTSON",
      company: "SEO COMPANY NAME",
      text: "Le portfolio de Viviworks.IA met en lumière la diversité et l'efficacité de nos projets conçus avec l'appui de l'intelligence artificielle. Grâce à l'IA, nous adaptons chaque création aux besoins uniques de nos clients, en combinant données, design et stratégie digitale pour atteindre des résultats mesurables. Découvrez comment l'intelligence artificielle amplifie notre créativité et propulse nos clients vers le succès en ligne."
    },
    {
      name: "DARLENE ROBERTSON",
      company: "SEO COMPANY NAME",
      text: "Le portfolio de Viviworks.IA met en lumière la diversité et l'efficacité de nos projets conçus avec l'appui de l'intelligence artificielle. Grâce à l'IA, nous adaptons chaque création aux besoins uniques de nos clients, en combinant données, design et stratégie digitale pour atteindre des résultats mesurables. Découvrez comment l'intelligence artificielle amplifie notre créativité et propulse nos clients vers le succès en ligne."
    }
  ];

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <section className="testimonials section" id="testimonials">
      <div className="testimonials-container">
        <p className="testimonials-subtitle">Témoignages Clients</p>
        <h2 className="testimonials-title">
          Ils ont fait confiance à <span className="highlight">Viviworks.IA</span>
        </h2>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-content">
                <h3 className="testimonial-name">{testimonial.name}</h3>
                <p className="testimonial-company">{testimonial.company}</p>
                <p className="testimonial-text">{testimonial.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="testimonials-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Aller au témoignage ${index + 1}`}
            />
          ))}
        </div>
      </div>

      <div className="testimonials-bg"></div>
    </section>
  );
}

export default Testimonials;

